export default __webpack_public_path__ + "static/media/tomatoPlant_x1440.a5683863.png";